module.exports = __webpack_public_path__ + "img/phone-whatsapp.91e7e4c2.png";